var map = {
	"./blackGold/safeBox/gameWalletIcon.png": 74733,
	"./brownGold/safeBox/gameWalletIcon.png": 1316,
	"./darkBlue/safeBox/gameWalletIcon.png": 90295,
	"./greenYellow/safeBox/gameWalletIcon.png": 13174,
	"./redGold/safeBox/gameWalletIcon.png": 66935,
	"./skyBlue/safeBox/gameWalletIcon.png": 10151,
	"./whiteGold/safeBox/gameWalletIcon.png": 32821,
	"./yellowWhite/safeBox/gameWalletIcon.png": 65872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70586;